import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { CardTypeEnum, StyledCheckIcon } from '@tryhackme/thm-ui-components';
import { useNavigate } from 'react-router-dom';
import { useSegmentTracking } from 'src/common/hooks/use-segment-tracking';
import { CertificationType } from 'src/common/enums/certification';
import { StyledPathCardContainer, StyledPathCardContent, StyledPathTag, StyledCurrentPathTag, StyledProgressContainer, StyledFlexContent } from '../path-card/path-card.styles';
export const CertificateRoadmapCard = ({
  certificate,
  concluded,
  recommended,
  isSmall,
  certificationType
}: {
  certificate: {
    code: string;
    title: string;
    url: string;
    image: string;
    type: string;
  } | undefined;
  concluded: boolean;
  recommended?: string;
  isSmall?: boolean;
  certificationType: CertificationType;
}) => {
  const navigate = useNavigate();
  const {
    triggerButtonClickEvent
  } = useSegmentTracking();
  const cardProps = {
    isCurrentPath: false
  };
  if (!certificate) {
    return null;
  }
  const handleCardClick = () => {
    triggerButtonClickEvent(`${certificationType.toLowerCase()}-ad-click`, 'premium-roadmap', `${certificationType.toLowerCase()}-path-card`);
    navigate(certificate.url);
  };
  return <StyledPathCardContainer {...cardProps} onClick={handleCardClick} $isSmall={isSmall} data-sentry-element="StyledPathCardContainer" data-sentry-component="CertificateRoadmapCard" data-sentry-source-file="certificate-roadmap-card.tsx">
      {recommended && recommended === certificate?.code && <StyledCurrentPathTag>Recommended for you</StyledCurrentPathTag>}
      <div style={{
      backgroundImage: `url(${certificate?.image || ''})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      width: '8rem',
      minHeight: '8rem',
      borderTopLeftRadius: '0.5rem',
      borderBottomLeftRadius: '0.5rem'
    }} />
      <StyledPathCardContent flexDirection="column" alignItems="flex-start" data-sentry-element="StyledPathCardContent" data-sentry-source-file="certificate-roadmap-card.tsx">
        <p>{certificate?.title}</p>
        <StyledFlexContent data-sentry-element="StyledFlexContent" data-sentry-source-file="certificate-roadmap-card.tsx">
          <StyledPathTag data-sentry-element="StyledPathTag" data-sentry-source-file="certificate-roadmap-card.tsx">{certificate?.type}</StyledPathTag>
        </StyledFlexContent>
      </StyledPathCardContent>
      <StyledProgressContainer data-sentry-element="StyledProgressContainer" data-sentry-source-file="certificate-roadmap-card.tsx">
        {concluded ? <StyledCheckIcon $cardType={CardTypeEnum.PATH} icon={faCheckCircle} data-testid="completed-icon" /> : undefined}
      </StyledProgressContainer>
    </StyledPathCardContainer>;
};